export default __webpack_public_path__ + "assets/android-pwa-install-screen.png";